import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Sidebar from '../Sidebar/Sidebar';
import Header from '../Header/Header';
import './Layout.css';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import i18n from '../../i18n';
import UserManage from '../../pages/User/UserManage';
import Register from '../../pages/register/Register';

import CertificationsList from '../../pages/certifications/ListCertifications';
import Surveys from '../../pages/SurveyQuestion/Surveys/Surveys';
import QuestionTable from '../../pages/SurveyQuestion/BankQuestions/questionCatalog';
import UpdateQuestion from '../../pages/SurveyQuestion/BankQuestions/UpdateQuestion';
import ExportSurvey from 'src/pages/SurveyQuestion/Surveys/ExportSurvey';
import UpdateSurvey from 'src/pages/SurveyQuestion/Surveys/UpdateSurvey';
import CreateQuestion from 'src/pages/SurveyQuestion/BankQuestions/CreateQuestion';
import CreateSurvey from 'src/pages/SurveyQuestion/Surveys/CreateSurvey';

const ViewControl = React.lazy(() => import('../../pages/compliance/assessment/viewControl'));

const Dashboard = React.lazy(() => import('../../pages/dashboard/Dashboard'));
const Standards = React.lazy(() => import('../../pages/referenes/references'));
const Login = React.lazy(() => import('../../pages/login/login'));
const Home = React.lazy(() => import('../../pages/home/home'))
const Tickets = React.lazy(() => import('../../pages/Tickets/Tickets'));
const ComplianceStatus = React.lazy(() => import('../../pages/compliance/complianceStatus/compliance_status'));
const Announcement = React.lazy(() => import('../../pages/Announcement/Announcement'));
const Report = React.lazy(() => import('../../pages/Report/Report'));
const Notification = React.lazy(() => import('../../pages/Notification/Notification'));
const AssignToCertifications = React.lazy(() => import('../../pages/certifications/AssignCertificaties'));


const Main: React.FC = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const location = useLocation();
    
    // Add a state to track if the user is authenticated
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    // Determine if the current route is the login page
    const isLoginPage = location.pathname === '/login' || location.pathname === '/register';

    // Simulate authentication check (replace with actual logic)
    useEffect(() => {
        const checkAuth = () => {
            // Replace with actual authentication check
            const user = localStorage.getItem('d_c_c_t'); // Example check
            setIsAuthenticated(!!user);
        };
        checkAuth();
    })
    const updateDirection = (lng: string) => {
        // Implement your direction update logic here
        console.log(`Direction updated for language: ${lng}`);
    };

    const handleLanguageChange = (lng: string) => {
        updateDirection(lng);
    };

    useEffect(() => {
        i18n.on('languageChanged', handleLanguageChange);

        // Cleanup listener on component unmount
        return () => {
            i18n.off('languageChanged', handleLanguageChange);
        };
    }, [handleLanguageChange]);

    return (
        <div className={`layout ${isSidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
            {!isLoginPage && 
         <Sidebar isOpen={isSidebarOpen} onToggle={toggleSidebar} language="en" />
}
            <div className={`${!isLoginPage ? 'main-content' : 'main-content-login w-100'}`}>
                <ToastContainer />
                {!isLoginPage && <Header onMobileToggle={toggleSidebar} />
            }
                <React.Suspense fallback={<div>Loading...</div>}>
                    <Routes>
                    <Route path="/" element={isAuthenticated ? <Dashboard /> : <Navigate to="/login" />} />

                        <Route path="/institutions" element={<Home />} />
                        <Route path="/announcement" element={<Announcement />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/ticket" element={<Tickets />} />
                        <Route path="/standards" element={<Standards />} />
                        <Route path="/user" element={<UserManage/>} />
                        <Route path="/register" element={<Register/>} />
                        <Route path="/reports" element={<Report/>} />
                        <Route path="/certifications" element={<CertificationsList/>} />
                        <Route path="/assign-certifications/:id" element={<AssignToCertifications/>} />
                        <Route path="/compliances/status/:id" element={<ComplianceStatus />} />
                        <Route path="/notification" element={<Notification/>} /> 
                        <Route path="/createQuestion" element={<CreateQuestion/>} /> 
                        <Route path="/create-survey" element={<CreateSurvey/>} /> 
                        <Route path="/export-survey/:id/:vendorId" element={<ExportSurvey/>} /> 
                        <Route path="/surveys" element={<Surveys/>} /> 
                        <Route path="/bankQuestions" element={<QuestionTable/>} /> 
                        <Route path="/updateQuestion/:id" element={<UpdateQuestion/>} />
                        <Route path="/surveys" element={<Surveys/>} /> 
                       <Route path="/compliances/view-control/:id/:fieldId/:subFieldId" element={<ViewControl />} />
                        
                        
                      
                        
                        
                    </Routes>
                </React.Suspense>
            </div>
        </div>
    );
};

export default Main;
